export const COLORS = {
  primary: '#F55109',
  secondary: '#2C2C2C',
}; 